import { defineStyles } from "@pandacss/dev";

const tableBorderStyles = defineStyles({
  outline: "none",
  borderWidth: "m",
  borderStyle: "solid",
  borderColor: "border.neutral.subtle",
  width: "100%",
  overflow: "hidden",
});

export default tableBorderStyles;
